export enum GoalPeriodStatus {
    Editing = 1,           // Célkitűzés
    SelfAssessment = 2,     // Önértékelés
    LeaderAssessment = 3,   // Vezetői értékelés
    Finished = 4,           // Befejezett
    Approved = 5            // Jóváhagyott
}